import { NewsList as News } from './NewsList'
import { OpportunitiesList as Opportunities } from './OpportunitiesList'
import { OpportunitiesListOfCard } from './OpportunitiesListOfCard'
import { SummaryList as Summary } from './SummaryList'

export default { News, Opportunities, OpportunitiesListOfCard, Summary }
